import React, {
  useRef,
  useState,
  FunctionComponent,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import {
  Block,
  Modal,
  Select,
  PanelHeader,
  IModalProps,
  AsyncSelect,
  IconName,
  Icon,
  Button,
  IIconProps,
  styled,
  BorderRadiusBase,
  FullInput,
  hsla,
  SelectStyles,
  Checkbox,
  Panel,
  IBlockProps,
  IconContainer,
  Input,
} from "../../../seenspire-library";
import * as Yup from "yup";
import { ActiveChannel, IClientApi } from "seenspire-api-client";
import { FeedType, isFeedType, translateCollection } from "../../util";
import { getToken } from "../../backend/session";
import { api } from "../../backend/api";
import { AppContext, useAppContext } from "../../state";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "../../components/ModalButtons/ModalButtons";
import {
  Source,
  CustomChannelSourceTypeEnum as TypesEnum,
  CustomChannelCustomFieldsEnum as TypeOptionsEnum,
  CustomChannelSourceItemTypeEnum,
  IFeedType,
  IFeedTypeOptions,
  CustomChannelSourceTypeEnum,
} from "../../interfaces";
import { components as SelectComponents } from "react-select";
import type { MenuListProps } from "react-select";

import {
  getNetworkIcon,
  SocialNetworkConfig,
  ISocialNetworksTypesConfig,
  enrichNetworks,
  SocialNetworks,
} from "../../containers/AccountSocialNetworks/AccountSocialNetworks";
import {
  hasIn,
  map,
  startCase,
  chain,
  filter,
  groupBy,
} from "lodash";
import ManageSocialNetworkModal from "../ManageSocialNetworkModal";
import { useToggle } from "react-use";
import {
  CURATION_TYPES_OPTIONS,
  hidePostsOptions,
  WEBEX_ONLY_MY_POSTS,
  SEARCH_DEBOUNCE_DURATION,
  orientationOptions,
} from "../../backend/consts";
import { pick, keys, get, last } from "lodash";
import {
  isTwitter,
  isTwitterTag,
  isInstagramBusiness,
  isInstagramBusinessTag,
  isFacebook,
  isLinkedIn,
  isWebEx,
  isWorkplace,
  isMicrosoftTeams,
  isYammer,
  // isZoom,
  isSlack,
} from "../../containers/ManageFeed/FeedUtils";
import { WarningPanel } from "../../containers/Auth/Login/Login";
import { SharePointSiteFields } from "./components/SharePointSiteFields";
import { PowerBiDashboardFields } from "./components/PowerBiDashboardFields";
import Tooltip from "../../components/Tooltip/Tooltip";

const ReactSelectInput = SelectComponents.Input;
const SelectOption = SelectComponents.Option;

const avatarStyle = {
  right: 20,
  bottom: -1,
  zIndex: 100,
  height: 34,
  width: 34,
  borderRadius: "50%",
  border: "2px solid white",
  boxShadow: "none",
};

export const SourceTypeConfig: any = {
  TWITTERACCOUNT: {
    networkLabel: "X",
    label: "X account",
    value: "TWITTERACCOUNT",
    icon: "twitter",
    prefixSign: "@",
    custom_fields: ["screen_name", "retweets", "replies"],
    listItems: null,
    note: null,
  },
  TWITTERTAG: {
    networkLabel: "X",
    label: "X hashtag",
    value: "TWITTERTAG",
    icon: "twitter",
    prefixSign: "#",
    custom_fields: ["tag"],
    listItems: null,
    note: null,
  },
  INSTACCOUNT: {
    networkLabel: "Instagram",
    label: "Instagram account",
    value: "INSTACCOUNT",
    icon: "instagrambusiness",
    prefixSign: "",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  FACEBOOKPAGE: {
    networkLabel: "Facebook",
    label: "Facebook page",
    value: "FACEBOOKPAGE",
    icon: "facebook",
    prefixSign: "",
    custom_fields: ["page_id", "pages", "page_name", "pagesearch"],
    listItems: null,
    note: null,
  },
  LINKEDINPAGE: {
    networkLabel: "LinkedIn",
    label: "LinkedIn Page",
    value: "LINKEDINPAGE",
    icon: "linkedIn",
    prefixSign: "",
    custom_fields: ["company_id", "page_name"],
    listItems: null,
    note: null,
  },
  WEBEXROOM: {
    networkLabel: "WebEx",
    label: "WebEx Room",
    value: "WEBEXROOM",
    icon: "webEx",
    prefixSign: "",
    custom_fields: ["room_id", "room_name", "hashtag", "my_posts_only"],
    listItems: null,
    note: null,
  },
  INSTAGRAMBUSINESSTAG: {
    networkLabel: "Instagram",
    label: "Instagram Business tag",
    value: "INSTAGRAMBUSINESSTAG",
    icon: "instagrambusiness",
    prefixSign: "#",
    custom_fields: ["instagram_business_account_id", "hashtag_id", "tag"],
    listItems: null,
    note: null,
  },
  INSTAGRAMBUSINESSBUSINESS: {
    networkLabel: "Instagram",
    label: "Instagram Business",
    value: "INSTAGRAMBUSINESSBUSINESS",
    icon: "instagrambusiness",
    prefixSign: "@",
    custom_fields: [
      "instagram_business_account_id",
      "fullName",
      "business_name",
    ],
    listItems: null,
    note: null,
  },
  WORKPLACEGROUP: {
    networkLabel: "Workplace",
    label: "Workplace Group",
    value: "WORKPLACEGROUP",
    icon: "workplace",
    prefixSign: "",
    custom_fields: ["group_id", "group_name"],
    listItems: null,
    note: null,
  },
  INSTAGRAMBUSINESSMENTION: {
    networkLabel: "Instagram",
    label: "Instagram Business mention",
    value: "INSTAGRAMBUSINESSMENTION",
    icon: "instagrambusiness",
    prefixSign: "@",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  MICROSOFTTEAMSCHANNEL: {
    networkLabel: "MS Teams",
    label: "MS Teams Channel",
    value: "MICROSOFTTEAMSCHANNEL",
    icon: "microsoftteams",
    prefixSign: "@",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  YAMMERCHANNEL: {
    networkLabel: "Viva Engage",
    label: "Viva Engage Channel",
    value: "YAMMERCHANNEL",
    icon: "vivaEngage",
    prefixSign: "@",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  SLACKCHANNEL: {
    networkLabel: "Slack",
    label: "Slack Channel",
    value: "SLACKCHANNEL",
    icon: "slack",
    prefixSign: "@",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  SHAREPOINTSITE: {
    networkLabel: "SharePoint",
    label: "SharePoint",
    value: "SHAREPOINTSITE",
    icon: "sharepoint",
    prefixSign: "",
    custom_fields: [],
    listItems: null,
    note: null,
  },
  // ZOOMROOM: {
  //   networkLabel: "Zoom",
  //   label: "Zoom Team Chat Channel'",
  //   value: "ZOOMROOM",
  //   icon: "zoom",
  //   prefixSign: "@",
  //   custom_fields: [],
  //   listItems: null,
  //   note: null,
  // }
  POWERBIDASHBOARD: {
    networkLabel: "Power BI",
    label: "Power BI Dashboard",
    value: "POWERBIDASHBOARD",
    icon: "powerbi",
    prefixSign: "",
    custom_fields: ["orientation", "rendertype"],
    listItems: null,
    note: null,
  },
  URL: {
    networkLabel: "URL",
    label: "URL",
    value: "URL",
    icon: "url2",
    prefixSign: "",
    custom_fields: ["url"],
    listItems: null,
    note: null,
  }
};

export const CustomFieldsConfig: {
  [key: string]: { title: string; icon: IconName; description: string };
} = {
  screen_name: {
    title: "Account Name",
    icon: "atSign",
    description: "",
  },
  account_name: {
    title: "Account Name",
    icon: "atSign",
    description: "",
  },
  tag: {
    title: "Tag",
    icon: "hashtag",
    description: "",
  },
  page_id: {
    title: "Page name",
    icon: "atSign",
    description: "",
  },
  pages: {
    title: "My pages",
    icon: "atSign",
    description: "",
  },
  pagesearch: {
    title: "Public page",
    icon: "atSign",
    description: "",
  },
  company_id: {
    title: "Company id",
    icon: "atSign",
    description: "",
  },
  room_id: {
    title: "Room id",
    icon: "atSign",
    description: "",
  },
  instagram_business_account_id: {
    title: "Account id",
    icon: "atSign",
    description: "",
  },
  hashtag_id: {
    title: "Hashtag id",
    icon: "hashtag",
    description: "",
  },
  business_name: {
    title: "Business name",
    icon: "atSign",
    description: "",
  },
  my_posts_only: {
    title: "My posts",
    icon: "atSign",
    description: "",
  },
  team_id: {
    title: "Your teams",
    icon: "atSign",
    description: "",
  },
  channel_id: {
    title: "Channel id",
    icon: "atSign",
    description: "",
  },
  channel_name: {
    title: "Channel name",
    icon: "atSign",
    description: "",
  },
  name: {
    title: "Channel name",
    icon: "atSign",
    description: "",
  },
  host_name: {
    title: "Host Name",
    icon: "atSign",
    description: "",
  },
  site_name: {
    title: "Site Name",
    icon: "atSign",
    description: "",
  },
};

const initialValues: Source = {
  networked_active_channel: 0,
  type: "",
  curation_type: CURATION_TYPES_OPTIONS[0].value,
  network_connection: 0,
  hide_older_than: hidePostsOptions[0].value,
  source_account_id: "",
  full_name: "",
  user_name: "",
  custom_fields: {
    name: "",
    screen_name: "",
    account_name: "",
    tag: "",
    retweets: false,
    replies: false,
    page_id: "",
    company_id: "",
    room_id: "",
    instagram_business_account_id: "",
    url: "",
    hashtag_id: "",
    business_name: "",
    orientation: "",
  },
};
interface IConnectionResultType {
  config: ISocialNetworksTypesConfig;
  types: IFeedType[];
}

const getHeaders = () => {
  const currentToken = getToken();

  const headers = {
    Authorization: `Bearer ${currentToken.access_token}`,
  };

  return headers;
};

export function getConnectionDetails(
  _connection: any,
  resultType: "config"
): ISocialNetworksTypesConfig;
export function getConnectionDetails(
  _connection: any,
  resultType: "types"
): IFeedType[];
export function getConnectionDetails(
  _connection: any,
  resultType: "config" | "types"
) {
  let types: IFeedType[];
  let config: ISocialNetworksTypesConfig;
  switch (true) {
    case hasIn(_connection.availableSourceTypes, TypesEnum.FACEBOOKPAGE):
      types = [
        {
          icon: "facebook",
          label: "Public pages",
          type: TypesEnum.FACEBOOKPAGE,
          option: TypeOptionsEnum.pagesearch,
          id: TypeOptionsEnum.page_id,
          customFieldsKeys: {
            link: null,
            page_name: null,
            page_id: null,
          },
        },
        /*
        {
          icon: 'facebook',
          label: 'My facebook pages',
          type: TypesEnum.FACEBOOKPAGE,
          option: TypeOptionsEnum.pages,
          id: TypeOptionsEnum.page_id,
          customFieldsKeys: {
            link: null,
            page_name: null,
            page_id: null
          }
        },
        */
      ];
      config = SocialNetworkConfig.facebook;
      break;

    case hasIn(_connection.availableSourceTypes, TypesEnum.TWITTERACCOUNT) ||
      hasIn(_connection.availableSourceTypes, TypesEnum.TWITTERTAG):
      types = [
        {
          icon: "twitter",
          label: "feeds.public_accounts",
          type: TypesEnum.TWITTERACCOUNT,
          option: TypeOptionsEnum.screen_name,
          queryResultId: "screen_name",
          id: TypeOptionsEnum.screen_name,
          customFieldsKeys: {
            retweets: null,
            replies: null,
            name: null,
            screen_name: null,
            handle_id: null,
          },
        },
        /*
        {
          static: true,
          icon: 'twitter',
          label: 'feeds.my_twitter_account',
          type: TypesEnum.TWITTERACCOUNT,
          option: TypeOptionsEnum.screen_name,
          id: TypeOptionsEnum.screen_name,
          customFieldsKeys: {
            retweets: null,
            replies: null,
            name: null,
            screen_name: null
          }
        },
        {
          icon: "hashtag",
          label: "Hashtag",
          type: TypesEnum.TWITTERTAG,
          option: TypeOptionsEnum.tag,
          id: TypeOptionsEnum.tag,
          customFieldsKeys: {
            retweets: null,
            replies: null,
            tag: null,
            handle_id: null,
          },
        }
        */
      ];

      config = SocialNetworkConfig.twitter;
      break;

    case hasIn(
      _connection.availableSourceTypes,
      TypesEnum.INSTAGRAMBUSINESSTAG
    ) ||
      hasIn(
        _connection.availableSourceTypes,
        TypesEnum.INSTAGRAMBUSINESSBUSINESS
      ):
      types = [
        {
          icon: "instagrambusiness",
          label: "Public account",
          type: TypesEnum.INSTAGRAMBUSINESSBUSINESS,
          option: TypeOptionsEnum.instagram_business_discovery,
          queryResultId: "name",
          queryResultExtraId: TypeOptionsEnum.instagram_business_account_id,
          id: TypeOptionsEnum.business_name,
          customFieldsKeys: {
            business_name: null,
            fullName: null,
            instagram_business_account_id: null,
          },
        }, // instagram_business_discovery?instagram_business_account=17841405378451529&query=apple
        /*
        {
          icon: 'instagrambusiness',
          label: 'My Instagram',
          type: TypesEnum.INSTAGRAMBUSINESSBUSINESS,
          option: TypeOptionsEnum.instagram_business_account_id,
          id: TypeOptionsEnum.instagram_business_account_id,
          customFieldsKeys: {
            business_name: null,
            fullName: null,
            instagram_business_account_id: null
          }
        }, // gets you the instagram_business_account_id 
        */
        {
          icon: "hashtag",
          label: "Hashtag",
          type: TypesEnum.INSTAGRAMBUSINESSTAG,
          queryResultId: "id",
          option: TypeOptionsEnum.hashtag_id,
          queryResultExtraId: TypeOptionsEnum.instagram_business_account_id,
          id: TypeOptionsEnum.hashtag_id,
          customFieldsKeys: {
            hashtag_id: null,
            instagram_business_account_id: null,
            tag: null,
          },
        }, // hashtag_id?instagram_business_account=17841405378451529&query=sam
      ];

      config = SocialNetworkConfig.instagrambusiness;
      break;
    case hasIn(_connection.availableSourceTypes, TypesEnum.LINKEDINPAGE):
      types = [
        {
          icon: "linkedIn",
          label: "My pages",
          type: TypesEnum.LINKEDINPAGE,
          option: TypeOptionsEnum.company_id,
          id: TypeOptionsEnum.company_id,
          customFieldsKeys: {
            company_id: null,
            page_name: null,
          },
        },
      ];
      config = SocialNetworkConfig.linkedin;
      break;
    case hasIn(_connection.availableSourceTypes, TypesEnum.WEBEXROOM):
      types = [
        {
          icon: "team",
          label: "feeds.webex_teams_space",
          type: TypesEnum.WEBEXROOM,
          option: TypeOptionsEnum.room_id,
          id: TypeOptionsEnum.room_id,
          customFieldsKeys: {
            room_id: null,
            room_name: null,
            hashtag: null,
            my_posts_only: null,
          },
        },
      ];
      config = SocialNetworkConfig.webex;
      break;
    case hasIn(_connection.availableSourceTypes, TypesEnum.WORKPLACEGROUP):
      types = [
        {
          icon: "workplace",
          label: "feeds.workplace_group",
          type: TypesEnum.WORKPLACEGROUP,
          option: TypeOptionsEnum.group_id,
          id: TypeOptionsEnum.group_id,
          customFieldsKeys: {
            group_id: null,
            group_name: null,
          },
        },
      ];
      config = SocialNetworkConfig.workplace;
      break;
    case hasIn(
      _connection.availableSourceTypes,
      TypesEnum.MICROSOFTTEAMSCHANNEL
    ):
      types = [
        {
          icon: "microsoftteams",
          label: "Team",
          secondaryLabel: "Channel",
          type: TypesEnum.MICROSOFTTEAMSCHANNEL,
          option: TypeOptionsEnum.team_id,
          id: TypeOptionsEnum.team_id,
          customFieldsKeys: {
            team_id: null,
            channel_id: null,
            channel_name: null,
          },
        },
      ];
      config = SocialNetworkConfig.microsoftteams;
      break;
    case hasIn(_connection.availableSourceTypes, TypesEnum.YAMMERCHANNEL):
      types = [
        {
          icon: "vivaEngage",
          label: "Channel Name",
          type: TypesEnum.YAMMERCHANNEL,
          option: TypeOptionsEnum.channel_id,
          id: TypeOptionsEnum.channel_id,
          customFieldsKeys: {
            channel_id: null,
            channel_name: null,
          },
        },
      ];
      config = SocialNetworkConfig.yammer;
      break;
    // case hasIn(_connection.availableSourceTypes, TypesEnum.ZOOMROOM):
    //   types = [
    //     {
    //       icon: "zoom",
    //       label: "Channel Name",
    //       type: TypesEnum.ZOOMROOM,
    //       option: TypeOptionsEnum.channel_id,
    //       id: TypeOptionsEnum.channel_id,
    //       customFieldsKeys: {
    //         channel_id: null,
    //         name: null,
    //       },
    //     },
    //   ];
    //   config = SocialNetworkConfig.zoom;
    //   break;

    case hasIn(_connection.availableSourceTypes, TypesEnum.SLACKCHANNEL):
      types = [
        {
          icon: "slack",
          label: "Channel Name",
          type: TypesEnum.SLACKCHANNEL,
          option: TypeOptionsEnum.channel_id,
          id: TypeOptionsEnum.channel_id,
          customFieldsKeys: {
            channel_id: null,
            name: null,
          },
        },
      ];
      config = SocialNetworkConfig.slack;
      break;

    case hasIn(_connection.availableSourceTypes, TypesEnum.SHAREPOINTSITE):
      types = [
        {
          icon: "sharepoint",
          label: "SharePoint Site",
          type: TypesEnum.SHAREPOINTSITE,
          option: TypeOptionsEnum.host_name,
          id: TypeOptionsEnum.host_name,
          customFieldsKeys: {
            site_id: null,
            display_name: null,
          },
        },
      ];
      config = SocialNetworkConfig.sharepoint;
      break;

    case hasIn(_connection.availableSourceTypes, TypesEnum.POWERBIDASHBOARD):
      types = [
        {
          icon: "powerbi",
          label: "PowerBI Dashboard",
          type: TypesEnum.POWERBIDASHBOARD,
          option: TypeOptionsEnum.dashboard_id,
          id: TypeOptionsEnum.dashboard_id,
          customFieldsKeys: {
            workspace_id: null,
            dashboard_id: null,
            dashboard_name: null,
            orientation: "landscape",
          },
        },
      ];
      config = SocialNetworkConfig.powerbi;
      break;
    default:
      types = [];
      config = SocialNetworkConfig.facebook;
  }
  return resultType === "types" ? types : config;
}

// plain div, not styled(SelectOption) - styled-components strips the theme
// prop react-select's Option reads directly, crashing its style functions
const LightSelectOptionWrapper = styled.div`
  .app-select__option--is-selected {
    background-color: hsl(211, 15%, 93%);
    color: hsl(211, 15%, 43%);
  }
`;

const customValueContainer = (base: any, state: any) => ({
  ...base,
  ...(SelectStyles.valueContainer
    ? SelectStyles.valueContainer(base, state)
    : {}),
  paddingLeft: 50,
});

const orderNetworks = (
  items: ISocialNetworksTypesConfig[],
  twitterEnabled = false
) => {
  const itemsOrdered: ISocialNetworksTypesConfig[] = [];
  const theOrder = [
    "facebook",
    "instagrambusiness",
    ...(twitterEnabled ? ["twitter"] : []),
    "linkedin",
    "microsoftteams",
    "sharepoint",
    "slack",
    "workplace",
    "yammer",
    // "zoom",
    "webex",
    "powerbi",
  ];

  theOrder.forEach((_item) => {
    const found = items.find((item) => item.name === _item);
    if (found) {
      itemsOrdered.push(found);
    }
  });

  return itemsOrdered;
};

const AddConnectionPanelStyled = styled(Block)<{ hasConnections: boolean }>`
  ${({ theme, hasConnections }) => `
    ${
      hasConnections
        ? `
      border-top:1px solid ${theme.colors.gray.lighter};
    `
        : ""
    }`}
`;

const AddConnectionPanel: FunctionComponent<
  IBlockProps & { hasConnections: boolean }
> = ({ hasConnections, ..._props }) => {
  return (
    <AddConnectionPanelStyled hasConnections={hasConnections} {..._props} />
  );
};

const OptionImageStyled = styled(Block).attrs({})<{ image: string }>`
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${({ image }) => image});
  ${BorderRadiusBase};
`;

const VerifiedResultsBadge = styled(Icon)`
  width: 14px;
  height: 14px;
`;

const OptionImage: FunctionComponent<{ image: string }> = ({ image }) => {
  return <OptionImageStyled image={image} />;
};
const SelectIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`;

const SelectwideIcon = styled(Icon)`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  > svg {
    width: 30px;
  }
`;

const MediumSelectIcon = styled(Icon)`
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
`;

const SmallSelectIcon = styled(Icon)`
  width: 16px;
  height: 16px;
`;

const MenuListItemsContainer = styled(Block)`
  max-height: 190px;
  overflow: hidden;
  overflow-y: auto;
`;

const IconLoading: FunctionComponent<
  IIconProps & {
    loadingIcon?: IconName;
    activeIcon: IconName;
    loading: boolean;
  }
> = ({
  loadingIcon,
  activeIcon,
  loading,
  color,
  strokeColor,
  strokeShade,
  ...props
}) => {
  return (
    <SelectIcon
      color={color || "gray"}
      strokeColor={loading ? strokeColor || "accent" : "transparent"}
      strokeShade={strokeShade || "light"}
      name={loading ? loadingIcon || "loading" : activeIcon}
      {...props}
    />
  );
};

export const OptionWithMedia: (
  mediaType: "icon" | "wideicon" | "smallicon" | "image" | "auto"
) => FunctionComponent<any> = (mediaType) => {
  return (selectProps) => {
    let media;
    switch (true) {
      case !!(mediaType === "auto" && selectProps.data.avatar):
        media = <OptionImage image={selectProps.data.avatar} />;
        break;

      case !!(mediaType === "icon"):
      case !!(mediaType === "auto" && selectProps.data.icon):
        media = (
          <SelectIcon
            color="gray"
            shade="lighter"
            name={selectProps.data.icon}
          />
        );
        break;

      case !!(mediaType === "wideicon"):
        media = (
          <SelectwideIcon
            color="gray"
            shade="lighter"
            overlayMedia={selectProps.data.image}
            overlayMediaProps={{ style: avatarStyle }}
            name={selectProps.data.icon}
          />
        );
        break;

      case !!(mediaType === "smallicon" && selectProps.data.icon):
        media = (
          <SmallSelectIcon
            color="gray"
            shade="lighter"
            name={selectProps.data.icon}
          />
        );
        break;

      case !!(mediaType === "image"):
        media = selectProps.data.avatar ? (
          <OptionImage image={selectProps.data.avatar} />
        ) : (
          <SelectIcon name="empty" />
        );
        break;

      default:
        break;
    }
    return (
      <LightSelectOptionWrapper>
        <SelectOption {...selectProps}>
          <Block
            padding={{
              all: mediaType === "smallicon" ? 10 : 0,
              left: 10,
              right: 10,
            }}
            gridGap={10}
            gridTemplate={
              mediaType === "wideicon" ? { columns: "45px 1fr" } : undefined
            }
            display="grid"
            direction="column"
            justifyContent="start"
            alignItems="center"
          >
            {media}
            <Block>
              <Block display="flex">
                {selectProps.children}
                {selectProps.data.verified && (
                  <VerifiedResultsBadge name="verifyBadge" />
                )}
              </Block>
              {selectProps.data.description && (
                <Block fontSize="smaller" opacity={0.75} margin={{ top: 2 }}>
                  {selectProps.data.description}
                </Block>
              )}
            </Block>
          </Block>
        </SelectOption>
      </LightSelectOptionWrapper>
    );
  };
};

const MenuListButton = styled(Button)<{
  svgWidth?: string;
  svgHeight?: string;
}>`
  height: 48px;
  width: 48px;
  border: 1px solid #dcdcdc;
  &:hover {
    border: 1px solid #dcdcdc;
    background-color: white;
  }
  ${IconContainer} {
    ${({ svgWidth }) => (svgWidth ? `width: ${svgWidth}!important;` : "")};
    ${({ svgHeight }) => (svgHeight ? `height: ${svgHeight}!important;` : "")};
  }
`;

const filterConnectedConnections = (network: any) =>
  network.status === "connected";
const filterConnectionPerFeedType =
  (feedType: FeedType) => (network: ISocialNetworksTypesConfig) =>
    feedType === network.feedType;
const enrichConnection = (c: any) => ({
  ...c,
  feedType: getConnectionDetails(c, "config").feedType,
  icon: getConnectionDetails(c, "config").icon,
  label: `${c.full_name || "Account Name"}`,
  description: `${c.user_name || ""}`,
  value: String(c.id),
});

export const getNetworksPerFeedType = async (
  channel: ActiveChannel,
  client: IClientApi
) => {
  const FEED_TYPE = isFeedType(channel);
  return await enrichNetworks(SocialNetworkConfig, client).then(
    ({
      facebook,
      instagrambusiness,
      twitter,
      linkedin,
      webex,
      /*workplace,*/ microsoftteams,
      yammer,
      // zoom,
      slack,
      sharepoint,
      powerbi,
    }) => {
      if (FEED_TYPE === "SOCIAL") {
        return { facebook, instagrambusiness, twitter, linkedin };
      } else if (FEED_TYPE === "TEAMS") {
        return {
          slack,
          microsoftteams,
          yammer,
          /* zoom,*/ webex /*, workplace*/,
          sharepoint,
        };
      } else if (FEED_TYPE === "DASHBOARD") {
        return {
          powerbi,
        };
      }
    }
  );
};

const transformConnections = (connectionsData: any, FEED_TYPE: any) => {

  return chain(connectionsData)
    .map(enrichConnection)
    .filter(filterConnectedConnections)
    .filter(filterConnectionPerFeedType(FEED_TYPE))
    .filter((item) => item.status === "connected")
    .value();
};
export const getConnectionPerFeedType = async (
  channel: ActiveChannel,
  client: IClientApi
): Promise<any> => {
  const FEED_TYPE = isFeedType(channel as any);
  return await client.NetworkConnections.getConnections().then((d: any) =>
    transformConnections(d.data, FEED_TYPE)
  );
};

const MenuList: FunctionComponent<
  MenuListProps<any> & {
    availableNetworks: ISocialNetworksTypesConfig[];
    onAddNewConnection: (network: ISocialNetworksTypesConfig) => void;
    hasConnections: boolean;
    channel: ActiveChannel;
  }
> = ({
  availableNetworks,
  onAddNewConnection,
  hasConnections,
  channel,
  ...props
}) => {
  const { twitterEnabled } = useAppContext();

  const columnLength =
    Object.values(availableNetworks).some((item) => item.name === "twitter") &&
    !twitterEnabled &&
    availableNetworks.length > 0
      ? availableNetworks.length - 1
      : availableNetworks.length || 4;

  const { t } = useTranslation();

  return (
    <SelectComponents.MenuList {...props}>
      {/* Menu items */}
      <MenuListItemsContainer>
        {props.options.length ? props.children : null}
      </MenuListItemsContainer>

      {/* Add new connection section */}
      <AddConnectionPanel
        bg="background"
        bgShade="dark"
        hasConnections={hasConnections}
      >
        {/* Title */}
        <Block
          padding={{ all: 10, top: 20 }}
          color="gray"
          shade="dark"
          fontSize="small"
          textAlign="center"
          textTransform="uppercase"
        >
          {
            isFeedType(channel) === "TEAMS"
              ? "Add a collaboration account" 
              : isFeedType(channel) === "DASHBOARD"
              ? "Add a new powerBi dashboard"
              : "Add a new social media account"
          }
        </Block>

        {/* Buttons */}
        <Block
          padding={{ all: 10, bottom: 24 }}
          display="grid"
          direction="column"
          gridGap={25}
          gridTemplate={{
            columns: `repeat(${columnLength}, 48px)`,
          }}
          justifyContent="center"
        >
          {orderNetworks(availableNetworks, twitterEnabled).map((network) => {

            let modWidth = undefined;
            switch (network.name) {
              case "microsoftteams":
              case "yammer":
                modWidth = "25px";
                break;
              case "webex":
                modWidth = "24px";
                break;
              default:
                modWidth = undefined;
            }

            return (
              <MenuListButton
                buttonType="transparent"
                key={network.name}
                elementHeightBase={false}
                elementWidth="block"
                icon={network.icon}
                svgWidth={modWidth}
                svgHeight={modWidth}
                onClick={() => onAddNewConnection(network)}
              />
            );
          })}
        </Block>
      </AddConnectionPanel>
    </SelectComponents.MenuList>
  );
};

const validationSchema = Yup.object().shape({
  networked_active_channel: Yup.number().required(),
  type: Yup.string().required(),
  curation_type: Yup.string().required(),
  network_connection: Yup.string().required(),
  hide_older_than: Yup.string().required(),
  custom_fields: Yup.object().shape({
    name: Yup.string(),
    screen_name: Yup.string(),
    account_name: Yup.string(),
    tag: Yup.string(),
    retweets: Yup.bool(),
    replies: Yup.bool(),
    page_id: Yup.string(),
    company_id: Yup.string(),
    room_id: Yup.string(),
    instagram_business_account_id: Yup.string(),
    url: Yup.string(),
    hashtag_id: Yup.string(),
    business_name: Yup.string(),
    group_id: Yup.string(),
    team_id: Yup.string(),
    channel_id: Yup.string(),
    channel_name: Yup.string(),
    orientation: Yup.string(),
  }),
});

const isValidFacebookCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.page_id") &&
    hasIn(source, "custom_fields.page_name") &&
    hasIn(source, "custom_fields.link") &&
    !!get(source, "custom_fields.page_id") &&
    !!get(source, "custom_fields.page_name")
  );
};

const isValidTwitterCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.name") &&
    hasIn(source, "custom_fields.replies") &&
    hasIn(source, "custom_fields.retweets") &&
    hasIn(source, "custom_fields.screen_name") &&
    !!get(source, "custom_fields.screen_name")
  );
};

const isValidTwitterTagCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.tag") &&
    hasIn(source, "custom_fields.replies") &&
    hasIn(source, "custom_fields.retweets") &&
    hasIn(source, "custom_fields.screen_name") &&
    !!get(source, "custom_fields.tag")
  );
};

const isValidInstagramBusinessCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.business_name") &&
    hasIn(source, "custom_fields.fullName") &&
    hasIn(source, "custom_fields.instagram_business_account_id") &&
    !!get(source, "custom_fields.business_name") &&
    !!get(source, "custom_fields.fullName") &&
    !!get(source, "custom_fields.instagram_business_account_id")
  );
};

const isValidInstagramBusinessTagCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.hashtag_id") &&
    hasIn(source, "custom_fields.instagram_business_account_id") &&
    hasIn(source, "custom_fields.tag") &&
    !!get(source, "custom_fields.hashtag_id") &&
    !!get(source, "custom_fields.instagram_business_account_id") &&
    !!get(source, "custom_fields.tag")
  );
};

const isValidLinkedInCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.company_id") &&
    hasIn(source, "custom_fields.page_name") &&
    !!get(source, "custom_fields.company_id") &&
    !!get(source, "custom_fields.page_name")
  );
};

const isValidWorkplaceCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.group_id") &&
    hasIn(source, "custom_fields.group_name") &&
    !!get(source, "custom_fields.group_id") &&
    !!get(source, "custom_fields.group_name")
  );
};

const isValidWebExCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.room_id") &&
    hasIn(source, "custom_fields.room_name") &&
    hasIn(source, "custom_fields.hashtag") &&
    hasIn(source, "custom_fields.my_posts_only") &&
    !!get(source, "custom_fields.room_name")
  );
};

const isValidMicrosoftTeamsCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.team_id") &&
    hasIn(source, "custom_fields.channel_id") &&
    hasIn(source, "custom_fields.channel_name") &&
    !!get(source, "custom_fields.team_id") &&
    !!get(source, "custom_fields.channel_id") &&
    !!get(source, "custom_fields.channel_name")
  );
};

const isValidYammerCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.channel_id") &&
    hasIn(source, "custom_fields.channel_name") &&
    !!get(source, "custom_fields.channel_id") &&
    !!get(source, "custom_fields.channel_name")
  );
};

// const isValidZoomCustomFields = (source: Source) => {
//   return (
//     hasIn(source, "custom_fields.channel_id") &&
//     hasIn(source, "custom_fields.channel_name") &&
//     !!get(source, "custom_fields.channel_id") &&
//     !!get(source, "custom_fields.channel_name")
//   );
// };

const isValidSlackCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.channel_id") &&
    hasIn(source, "custom_fields.name") &&
    !!get(source, "custom_fields.channel_id") &&
    !!get(source, "custom_fields.name")
  );
};

const isValidSharePointCustomFields = (source: Source) => {
  return (
    hasIn(source, "custom_fields.host_name") &&
    hasIn(source, "custom_fields.site_name") &&
    !!get(source, "custom_fields.host_name") &&
    !!get(source, "custom_fields.site_name")
  );
};

const isValidSource = (source: Source, feedType: IFeedType | undefined) => {
  if (!feedType) return false;
  switch (true) {
    case isTwitter(feedType) && isValidTwitterCustomFields(source):
      return true;
    case isTwitterTag(feedType) && isValidTwitterTagCustomFields(source):
      return true;
    case isFacebook(feedType) && isValidFacebookCustomFields(source):
      return true;
    case isInstagramBusiness(feedType) &&
      isValidInstagramBusinessCustomFields(source):
      return true;
    case isInstagramBusinessTag(feedType) &&
      isValidInstagramBusinessTagCustomFields(source):
      return true;
    case isLinkedIn(feedType) && isValidLinkedInCustomFields(source):
      return true;
    case isWorkplace(feedType) && isValidWorkplaceCustomFields(source):
      return true;
    case isWebEx(feedType) && isValidWebExCustomFields(source):
      return true;
    case isMicrosoftTeams(feedType) &&
      isValidMicrosoftTeamsCustomFields(source):
      return true;
    case isYammer(feedType) && isValidYammerCustomFields(source):
      return true;
    case isSlack(feedType) && isValidSlackCustomFields(source):
      return true;
    case isSharePoint(feedType) && isValidSharePointCustomFields(source):
      return true;
    default:
      return false;
  }
};

const isSharePoint = (feedType: IFeedType | undefined) =>
  feedType?.type === TypesEnum.SHAREPOINTSITE;

const singleInputCustomStyles = {
  input: { padding: { left: 51 } },
  label: { left: 51 },
};
const AddFeedModal: FunctionComponent<
  IModalProps & { channel: ActiveChannel; firstItem: any }
> = ({ onSubmit, onCancel, channel, firstItem, ...props }) => {
  const FEED_TYPE = isFeedType(channel as any);
  const isDashboard = FEED_TYPE === "DASHBOARD";
  const isUrl = FEED_TYPE === "URL";
  const { slug, client, theme } = useContext(AppContext);
  const { t } = useTranslation();
  const [source, setSource] = useState<Source>({
    ...initialValues,
    networked_active_channel: channel.id,
  });
  const asyncSelectRef = useRef(null);
  const asyncInputRef = useRef<HTMLInputElement>(null);
  const hasAutoFocusedAsyncInput = useRef(false);
  // react-select v5 reports both "selected an option" and "backspaced the
  // last character" as the same (input === "", action === "set-value")
  // event - a flag set only on real selection distinguishes them, instead
  // of dropping every empty set-value (which made the field un-clearable).
  const justSelectedOptionRef = useRef(false);
  // Stable identity is required here: react-select treats a new function
  // reference as a new component type and remounts the actual <input> DOM
  // node on every render. AddFeedModal re-renders on every keystroke in
  // *any* field (it's one big component), so an inline `components` object
  // here was remounting this input every render, dropping focus/keystrokes
  // - both in this field and, via the same remount cycle, interfering with
  // other fields typed into while this AsyncSelect stays mounted alongside
  // them (e.g. the Hashtag field, per screenshot flow).
  const asyncSelectComponents = useMemo(
    () => ({
      Option: OptionWithMedia("auto"),
      Input: ({ innerRef, ...props }: any) => {
        return (
          <ReactSelectInput
            innerRef={function (ref: HTMLInputElement | null) {
              innerRef?.(ref);
              if (ref) {
                asyncInputRef.current = ref;
                if (!hasAutoFocusedAsyncInput.current) {
                  hasAutoFocusedAsyncInput.current = true;
                  ref.focus();
                }
              }
            }}
            {...props}
            isHidden={false}
          />
        );
      },
    }),
    []
  );
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [connection, setConnection] = useState<any>();
  const [types, setTypes] = useState<IFeedType[]>();
  const [selectedType, setSelectedType] = useState<IFeedType>();
  const [typeOptions, setTypeOptions] = useState<IFeedTypeOptions[]>();
  const [typeSecondaryOptions, setTypeSecondaryOptions] =
    useState<IFeedTypeOptions[]>();
  const [query, setQuery] = useState<any>();
  const [selectedTypeOption, setSelectedTypeOption] = useState<
    (IFeedTypeOptions & { label: string; value: string }) | undefined
  >();
  const [selectedTypeSecondaryOption, setSelectedTypeSecondaryOption] =
    useState<
      (IFeedTypeOptions & { label: string; value: string }) | undefined
    >();
  const [singleInputOption, setSingleInputOption] = useState({
    active: false,
    value: "",
  });
  const [asyncInputValue, setAsyncInputValue] = useState<string>();

  // Restore focus to this field specifically after its own value changes.
  // hasAutoFocusedAsyncInput only ever focuses once (by design, to stop the
  // old unconditional-focus-on-every-render behavior from stealing focus
  // away from *other* fields) - but react-select v5's internal menu/option
  // updates can still steal focus back off this input as you type, and
  // with nothing left to restore it, each keystroke after the first goes
  // nowhere until you click back in. Scoping this to asyncInputValue means
  // it only fires from this field's own typing, not from unrelated state
  // changes elsewhere in the modal - it can't reintroduce the original bug.
  useEffect(() => {
    if (
      hasAutoFocusedAsyncInput.current &&
      asyncInputRef.current &&
      document.activeElement !== asyncInputRef.current
    ) {
      const el = asyncInputRef.current;
      el.focus();
      // Programmatic .focus() on a text input can trigger the browser's
      // default select-all-on-focus - collapse the cursor to the end so a
      // single Backspace right after only deletes one character, not the
      // whole selected value.
      const end = el.value.length;
      el.setSelectionRange(end, end);
    }
  }, [asyncInputValue]);

  const [errors, setErrors] = useState({ error: false, message: "" });
  const [isValid, setValid] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isOpen, toggleModal] = useToggle(false);
  const [selectedNetwork, setSelectedNetwork] =
    useState<ISocialNetworksTypesConfig>(SocialNetworkConfig.facebook);
  const [availableNetworks, setAvailableNetworks] =
    useState<Awaited<ReturnType<typeof getNetworksPerFeedType>>>();
  // was useState - every debounce restart called setTimeoutState, which by
  // itself forced an extra re-render on every keystroke; a ref doesn't
  const asyncSearchTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null
  );
  // Add new state for API loading
  const [isValidating, setIsValidating] = useState(false);

  // Move these state declarations to the top level
  const [hostNameInput, setHostNameInput] = useState("");
  const [siteNameInput, setSiteNameInput] = useState("");
  // Add ref to store the current AbortController
  const abortControllerRef = useRef<AbortController | null>(null);

  const [isSharePointValidating, setIsSharePointValidating] = useState(false);
  const [isPowerBiValidating, setIsPowerBiValidating] = useState(false);

  useEffect(() => {
    // Reset inputs when source type changes
    setHostNameInput("");
    setSiteNameInput("");
    setIsValidating(false);
    setValid(false);
    
    // Cleanup: abort any pending requests
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [source.type]);

  useEffect(() => {
    setLoading(true);
    getNetworksPerFeedType(channel, client).then((results) => {

      setAvailableNetworks(results);
      loadData().finally(() => {
        setLoading(false);
      });
    });
  }, []);

  useEffect(() => {
    if (isUrl && source.custom_fields.url) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [source.custom_fields])

  useEffect(() => {
    if (connection) {
      const _types = getConnectionDetails(connection, "types");
      setTypes(_types);
      if (_types && _types.length > 0) {
        onTypeChange(_types[0]);
      }
    }
  }, [connection]);

  useEffect(() => {
    if (!source || !selectedType) return;
    
    if (source.type === TypesEnum.POWERBIDASHBOARD) {
      const isPowerBiValid = !!(
        source.custom_fields?.workspace_id &&
        source.custom_fields?.dashboard_id &&
        source.custom_fields?.dashboard_name &&
        source.custom_fields?.orientation
      );

      setValid(isPowerBiValid);
    } else {
      setValid(isValidSource(source, selectedType));
    }
  }, [source, selectedType]);

  const loadData = async () => {
    try {
      const _connections = await getConnectionPerFeedType(channel, client);
      setConnections(_connections ?? []);
      return _connections ?? [];
    } catch (error) {
      console.error('Error loading connections:', error);
      setErrors({ error: true, message: "Failed to load connections" });
      return [];
    }
  };

  const selectConnection = (selected: any) => {
    onConnectionChange(selected);
    setSource({ ...source, network_connection: selected.value });
  };

  const onConnectionAdded = async () => {
    const knownIds = new Set(connections.map((c: any) => c.value));
    const _connections = await loadData();
    toggleModal(false);
    const added = _connections.find((c: any) => !knownIds.has(c.value));
    if (added) selectConnection(added);
  };

  const initialAddConnection = (network: ISocialNetworksTypesConfig) => {
    setSelectedNetwork(network);
    toggleModal(true);
  };

  const onConnectionChange = (_connection: any) => {
    resetFields();
    setConnection({
      ..._connection,
      config: getConnectionDetails(_connection, "config"),
    });
  };

  const getMicrosoftTeamsChannelsData = async ({
    selectedTypeOption,
    type,
    connection,
  }: any) => {
    let secondaryOptions: IFeedTypeOptions[] =
      (await client.NetworkConnections.getCustomOptions(
        connection.id,
        type.type,
        TypeOptionsEnum.channel_id,
        selectedTypeOption.id,
        {
          query: { team_id: selectedTypeOption.id },
        }
      )) as any;
    secondaryOptions = secondaryOptions.map(
      (i) => ({ ...i, id: i.channel_id, name: i.channel_name } as any)
    );
    const selectedTypeSecondaryOption = secondaryOptions[0]
      ? {
          ...secondaryOptions[0],
          label: secondaryOptions[0].name,
          value: secondaryOptions[0].id,
        }
      : undefined;
    return {
      secondaryOptions,
      selectedTypeSecondaryOption,
    };
  };
  const onTypeChange = async (_type: IFeedType) => {
    setErrors({ error: false, message: "" });
    setSelectedType(_type);
    resetFields();
    
    // Set initial source state for PowerBI
    if (_type.type === TypesEnum.POWERBIDASHBOARD) {
      setSource({
        ...source,
        type: _type.type,
        curation_type: "AUTO_APPROVE",
        hide_older_than: "-1",
        custom_fields: {
          workspace_id: null,
          dashboard_id: null,
          dashboard_name: null,
          orientation: "landscape",
          rendertype: "image",
        },
      });
      return;
    }
    
    // Rest of the onTypeChange logic
    let options: IFeedTypeOptions[] = [];
    let secondaryOptions: IFeedTypeOptions[] = [];

    let _selectedTypeOption;
    let _selectedTypeSecondaryOption;
    let firstOption;
    let full_name: string = "";
    let custom_fields: any = {};

    try {
      switch (true) {
        case _type.type === TypesEnum.FACEBOOKPAGE &&
          _type.option === TypeOptionsEnum.pages:
        case _type.type === TypesEnum.INSTAGRAMBUSINESSBUSINESS &&
          _type.option === TypeOptionsEnum.instagram_business_account_id:
        case _type.type === TypesEnum.LINKEDINPAGE &&
          _type.option === TypeOptionsEnum.company_id:
        case _type.type === TypesEnum.WEBEXROOM &&
          _type.option === TypeOptionsEnum.room_id:
        case _type.type === TypesEnum.WORKPLACEGROUP &&
          _type.option === TypeOptionsEnum.group_id:
        case _type.type === TypesEnum.MICROSOFTTEAMSCHANNEL &&
          _type.option === TypeOptionsEnum.team_id:
          options = (await client.NetworkConnections.getCustomOptions(
            connection.id,
            _type.type,
            _type.option
          )) as any;

          if (_type.type === TypesEnum.LINKEDINPAGE)
            options = options.map((i) => ({ ...i, name: startCase(i.name) }));

          if (_type.type === TypesEnum.MICROSOFTTEAMSCHANNEL)
            options = options.map(
              (i) => ({ ...i, id: i.team_id, name: i.team_name } as any)
            );

          firstOption = options[0];

          _selectedTypeOption = firstOption
            ? { ...firstOption, label: firstOption.name, value: firstOption.id }
            : undefined;

          if (firstOption) {
            custom_fields = {
              ...source.custom_fields,
              [_type.id]: firstOption.id,
              page_name: firstOption.page_name || firstOption.name,
              group_name: firstOption.group_name || firstOption.name,
              room_name: firstOption.room_name || firstOption.name,
              link: firstOption.link || "",
            };
          }

          if (_type.type === TypesEnum.INSTAGRAMBUSINESSBUSINESS) {
            custom_fields[TypeOptionsEnum.business_name] = firstOption.name;
            custom_fields.fullName = firstOption.fullName;
          }

          if (_type.type === TypesEnum.WEBEXROOM) {
            custom_fields = {
              ...custom_fields,
              hashtag: "",
              my_posts_only: false,
            };
          }

          if (
            _type.type === TypesEnum.MICROSOFTTEAMSCHANNEL &&
            _selectedTypeOption
          ) {
            const microsoftTeamsChannelsData =
              await getMicrosoftTeamsChannelsData({
                type: _type,
                selectedTypeOption: _selectedTypeOption,
                connection,
              });
            secondaryOptions = microsoftTeamsChannelsData.secondaryOptions;
            _selectedTypeSecondaryOption =
              microsoftTeamsChannelsData.selectedTypeSecondaryOption;
            custom_fields = {
              ...custom_fields,
              team_id:
                _selectedTypeSecondaryOption &&
                _selectedTypeSecondaryOption.team_id,
              channel_id:
                _selectedTypeSecondaryOption &&
                _selectedTypeSecondaryOption.channel_id,
              channel_name:
                _selectedTypeSecondaryOption &&
                _selectedTypeSecondaryOption.channel_name,
            };
          }

          full_name = firstOption.name;
          break;

        case _type.type === TypesEnum.TWITTERACCOUNT &&
          _type.option === TypeOptionsEnum.screen_name &&
          _type.static:
          options = [
            {
              name: connection.user_name || "No Label",
              id: connection.full_name,
              avatar: connection.avatar,
              screen_name: connection.full_name,
            },
          ];
          firstOption = options[0];
          _selectedTypeOption = {
            ...firstOption,
            label: firstOption.name,
            value: firstOption.id,
          };

          custom_fields = {
            [_type.id]: firstOption.name,
            name: connection.full_name || "",
            retweets: source.custom_fields.retweets,
            replies: source.custom_fields.replies,
            handle_id: undefined,
          };
          break;

        case _type.type === TypesEnum.TWITTERACCOUNT &&
          _type.option === TypeOptionsEnum.screen_name &&
          !_type.static:
          setQuery({
            id: connection.id,
            type: _type.type,
            option: _type.option,
            icon: _type.icon,
            params: {},
          });

          custom_fields = {
            ...source.custom_fields,
            [_type.id]: null,
            retweets: source.custom_fields.retweets,
            replies: source.custom_fields.replies,
            handle_id: undefined,
          };

          break;

        case _type.type === TypesEnum.TWITTERTAG &&
          _type.option === TypeOptionsEnum.tag:
          custom_fields = {
            ...source.custom_fields,
            [_type.id]: null,
            retweets: source.custom_fields.retweets,
            replies: source.custom_fields.replies,
            handle_id: undefined,
          };
          setSingleInputOption({ active: true, value: "" });
          break;

        case _type.type === TypesEnum.SLACKCHANNEL &&
          _type.option === TypeOptionsEnum.channel_id:
          let slackParams = {};

          setQuery({
            id: connection.id,
            type: _type.type,
            option: _type.option,
            icon: _type.icon,
            slackParams,
          });

          break;

        case _type.type === TypesEnum.YAMMERCHANNEL &&
          _type.option === TypeOptionsEnum.channel_id:
          let yammerParams = {};

          setQuery({
            id: connection.id,
            type: _type.type,
            option: _type.option,
            icon: _type.icon,
            yammerParams,
          });

          break;

        case _type.type === TypesEnum.FACEBOOKPAGE &&
          _type.option === TypeOptionsEnum.pagesearch:
        case _type.type === TypesEnum.INSTAGRAMBUSINESSTAG &&
          _type.option === TypeOptionsEnum.hashtag_id:
        case _type.type === TypesEnum.INSTAGRAMBUSINESSBUSINESS &&
          _type.option === TypeOptionsEnum.instagram_business_discovery:
          let params = {};

          if (
            _type.type === TypesEnum.INSTAGRAMBUSINESSBUSINESS ||
            _type.type === TypesEnum.INSTAGRAMBUSINESSTAG
          ) {
            const instagram_business_account =
              (await client.NetworkConnections.getCustomOptions(
                connection.id,
                _type.type,
                TypeOptionsEnum.instagram_business_account_id
              )) as any;
            if (!instagram_business_account[0]) {
              console.error(
                `[AddFeedModal] No instagram_business_account found form ${connection.id}`
              );
              throw new Error("");
              break;
            }
            params = {
              instagram_business_account: instagram_business_account[0].id,
              instagram_business_account_id: instagram_business_account[0].id,
            };
          }

          setQuery({
            id: connection.id,
            type: _type.type,
            option: _type.option,
            icon: _type.icon,
            params,
          });

          // _selectedTypeOption = { label: t('feeds.search_account') };
          break;
        case _type.type === TypesEnum.WEBEXROOM &&
          _type.option === TypeOptionsEnum.hashtag:
          setSingleInputOption({ active: true, value: "" });
          break;
        default:
          break;
      }

      const enrichedOptions = options.map((i) => ({ ...i, icon: _type.icon }));
      const enrichedSecondaryOptions = secondaryOptions.map((i) => ({
        ...i,
        icon: _type.icon,
      }));
      setTypeOptions(enrichedOptions);
      setTypeSecondaryOptions(enrichedSecondaryOptions);
      setSelectedTypeOption(_selectedTypeOption);
      setSelectedTypeSecondaryOption(_selectedTypeSecondaryOption);
      setSource({ ...source, full_name, type: _type.type, custom_fields });
      setLoading(false);
    } catch (error) {
      resetFields();
      setErrors({
        error: true,
        message:
          "Issue selecting accounts or sources, please try again or contact support!",
      });
      setLoading(false);
    }
  };

  const resetFields = () => {
    setSelectedTypeOption(undefined);
    setTypeOptions(undefined);
    setQuery(undefined);
    setSingleInputOption({ active: false, value: "" });
  };

  // was `debounce(fn, 0)` (a no-op - 0ms wait doesn't debounce anything)
  // wrapping an inline arrow function recreated on every render. Passing an
  // unstable `loadOptions` reference to react-select's Async wrapper (v5;
  // this behaves very differently from the v2 this app used to run) was
  // triggering a full remount/reload cascade on every keystroke anywhere
  // in the modal - useCallback keeps identity stable across renders and
  // only changes when the actual search target (query/connection) does.
  const loadAsyncOptions = useCallback((value: any, cb: any) => {
    if (!value) {
      return;
    }

    if (asyncSearchTimeoutRef.current) {
      clearTimeout(asyncSearchTimeoutRef.current);
    }

    asyncSearchTimeoutRef.current = setTimeout(async () => {
      client.NetworkConnections.getCustomOptions(
        query.id,
        query.type,
        query.option,
        String(value).toLowerCase(),
        {
          query: { ...query.params },
        }
      )
        .then((data: any) => {
          const options = data
            ? data.map((d: any) => ({
                ...d,
                label: d.name || d.channel_name || value,
                value: d.id || d.channel_id,
                icon: query.icon,
                description: d.screen_name && `@${d.screen_name}`,
              }))
            : [];
          cb(options);
          // Delivering results back to react-select can itself trigger an
          // internal remount (separate from the loadOptions-identity issue
          // already fixed) - the new DOM node reuses the same generated id,
          // so it looks like nothing changed, but focus doesn't carry over.
          // Deferred so it runs after react-select's own update settles.
          // This also fires right as the option list becomes clickable, so
          // skip it while the menu is actually open - forcing focus back to
          // the input mid-click was interrupting real option selection
          // (the field would show typed text but never fire onChange).
          setTimeout(() => {
            const menuOpen = !!document.querySelector(".app-select__menu");
            if (
              !menuOpen &&
              hasAutoFocusedAsyncInput.current &&
              asyncInputRef.current &&
              document.activeElement !== asyncInputRef.current
            ) {
              const el = asyncInputRef.current;
              el.focus();
              const end = el.value.length;
              el.setSelectionRange(end, end);
            }
          }, 0);
        })
        .catch((error) => {
          if (get(error, "response.data.code") === 100) {
            cb([]);
            return;
          }
          cb([
            {
              error: true,
              label: "Oops, an error has occurred!",
              description: "Please try again, or contact support.",
              icon: "error",
            },
          ]);
          console.error(
            `[AddFeedModal] error fetching results ${connection.id}`
          );

          if (error.response.data.error === "too long") {
            cb([
              {
                error: true,
                label: "Oops, an error has occurred!",
                description:
                  "The channel name entered is too short, please expand the name or enter the full channel name.",
                icon: "error",
              },
            ]);
          } else {
            cb([
              {
                error: true,
                label: "Oops, an error has occurred!",
                description: "Please try again, or contact support.",
                icon: "error",
              },
            ]);
            console.error(
              `[AddFeedModal] error fetching results ${connection.id}`
            );
          }
        });
    }, 1500);
  }, [query, connection, client]);

  const generateSourceCustomFieldsPerType = (
    source: any,
    feedType: IFeedType | undefined
  ) => {
    return feedType && feedType.customFieldsKeys
      ? pick(source.custom_fields, keys(feedType.customFieldsKeys))
      : {};
  };

  const submit = async () => {
    if (!isValid || isSubmitting) return;
  
    setSubmitting(true);
  
    const sourceAtSubmitTime = JSON.parse(JSON.stringify(source));
  
    try {
      let finalCustomFields: any;
  
      if (isUrl) {
        finalCustomFields = {
          url: sourceAtSubmitTime.custom_fields?.url || "",
        };
      } else {
        let tempCustomFields = { ...sourceAtSubmitTime.custom_fields };
  
        if (isTwitter(selectedType) || isTwitterTag(selectedType)) {
          tempCustomFields.retweets = !!tempCustomFields.retweets;
          tempCustomFields.replies = !!tempCustomFields.replies;
        }

        if (selectedType?.type === TypesEnum.POWERBIDASHBOARD) {
          if (tempCustomFields.rendertype) {
            tempCustomFields.rendertype = tempCustomFields.rendertype;
          }
        }

        finalCustomFields = generateSourceCustomFieldsPerType(
          { ...sourceAtSubmitTime, custom_fields: tempCustomFields },
          selectedType
        );
        if (
          selectedType?.type === TypesEnum.POWERBIDASHBOARD &&
          tempCustomFields.rendertype
        ) {
          finalCustomFields.rendertype = tempCustomFields.rendertype;
        }
      }

      const payloadSource = {
        ...sourceAtSubmitTime,
        custom_fields: finalCustomFields,
        network_connection: isUrl ? null : source.network_connection,
        type: isUrl ? 'URL' : source.type,
        hide_older_than:
          firstItem && firstItem.hide_older_than
            ? firstItem.hide_older_than
            : sourceAtSubmitTime.hide_older_than,
      };
  
      await client.Sources.postSource(payloadSource as any).then((response) => {
        onSubmit(response);
      });
    } catch (error) {
      console.error("Error during submit:", error);
      setErrors({ error: true, message: "Issue submitting selected source" });
    } finally {
      setSubmitting(false);
    }
  };

  const onDynamicAccountChange = (selected: any) => {
    if (!selectedType) return;
    if (selected.error) return;

    const custom_fields = {
      ...source.custom_fields,
      [selectedType.id]:
        selectedType.queryResultId && selected[selectedType.queryResultId]
          ? selected[selectedType.queryResultId]
          : selected.id || selected.channel_id,
      retweets: source.custom_fields.retweets,
      replies: source.custom_fields.replies,
      name: selected.name || undefined,
      channel_name: selected.channel_name || undefined,
      fullName: selected.fullName || selected.name,
      business_name: selected.name,
      link: selected.link,
      page_name: selected.user_name || selected.name,
      tag: selected.label,
      handle_id: selected.id,
    };

    if (selectedType.queryResultExtraId) {
      custom_fields[selectedType.queryResultExtraId] =
        query.params[selectedType.queryResultExtraId];
    }

    setSelectedTypeOption(selected);
    setSource({
      ...source,
      full_name: selected.label,
      custom_fields,
    });
  };

  const onStaticAccountChange = async (
    selected: any,
    fromSecondaryOption?: boolean
  ) => {
    if (!selectedType) return;

    let _source = source;

    if (
      selectedType.type === TypesEnum.MICROSOFTTEAMSCHANNEL &&
      !fromSecondaryOption
    ) {
      setLoading(true);
      const microsoftTeamsChannelsData = await getMicrosoftTeamsChannelsData({
        type: selectedType,
        selectedTypeOption: selected,
        connection,
      });
      setTypeSecondaryOptions(microsoftTeamsChannelsData.secondaryOptions);
      setSelectedTypeSecondaryOption(
        microsoftTeamsChannelsData.selectedTypeSecondaryOption
      );
      _source = {
        ...source,
        custom_fields: {
          ...source.custom_fields,
          channel_id:
            microsoftTeamsChannelsData.selectedTypeSecondaryOption &&
            microsoftTeamsChannelsData.selectedTypeSecondaryOption.id,
        },
      };
      setLoading(false);
    }

    if (fromSecondaryOption) {
      setSelectedTypeSecondaryOption(selected);
      _source = {
        ..._source,
        custom_fields: {
          ..._source.custom_fields,
          channel_id: selected.id,
          channel_name: selected.name,
        },
      };
    } else {
      _source = {
        ..._source,
        custom_fields: {
          ..._source.custom_fields,
          [selectedType.id]: selected.id,
          name: selected.name,
          fullName: selected.fullName,
          business_name: selected.name,
          page_name: selected.user_name || selected.name,
          link: selected.link || "",
          group_name: selected.name,
          room_name: selected.name,
          channel_name: selected.name,
        },
      };
      setSelectedTypeOption(selected);
    }

    setSource(_source);
  };

  const onSingleInputChange = (value: any) => {
    if (!selectedType) return;
    setSingleInputOption({ active: true, value });
    setSource({
      ...source,
      full_name: value,
      custom_fields: {
        ...source.custom_fields,
        [selectedType.id]: value,
        retweets: source.custom_fields.retweets,
        replies: source.custom_fields.replies,
      },
    });
  };

  const hasConnections = connections && connections.length > 0 ? true : false;
  const isTeams = isFeedType(channel) === "TEAMS";

  const [slackSearch] = useState(true);
  const [yammerSearch] = useState(true);
  const [slackId, setSlackId] = useState("");

  const renderSharePointFields = () => {
    if (source.type === TypesEnum.SHAREPOINTSITE && selectedType) {
      return (
        <SharePointSiteFields
          connection={connection}
          selectedType={selectedType}
          singleInputCustomStyles={singleInputCustomStyles}
          onValidationChange={setValid}
          onFieldsChange={(fields) => {
            setSource({
              ...source,
              custom_fields: {
                ...source.custom_fields,
                ...fields
              }
            });
          }}
          onError={setErrors}
          onValidatingChange={setIsSharePointValidating}
        />
      );
    }
    return null;
  };

  const renderPowerBiFields = () => {
    if (source.type === TypesEnum.POWERBIDASHBOARD && selectedType) {
      return (
        <PowerBiDashboardFields
          connection={connection}
          selectedType={selectedType}
          singleInputCustomStyles={singleInputCustomStyles}
          onValidationChange={(isValid) => {
            setIsPowerBiValidating(false);
            setValid(isValid);
          }}
          onFieldsChange={(fields) => {
            setIsPowerBiValidating(true);
            setSource(prevSource => {
              const newSource = {
                ...prevSource,
                custom_fields: {
                  ...prevSource.custom_fields,
                  ...fields
                }
              };
              // Immediately validate after updating source
              const isPowerBiValid = !!(
                fields.workspace_id &&
                fields.dashboard_id &&
                fields.dashboard_name &&
                fields.orientation
              );
              setValid(isPowerBiValid);
              setIsPowerBiValidating(false);
              return newSource;
            });
          }}
          onError={setErrors}
          onValidatingChange={(validating) => {

            setIsPowerBiValidating(validating);
          }}
        />
      );
    }
    return null;
  };

  return (
    <Modal 
      onRequestClose={() => onCancel()} 
      theme={theme} 
      {...props} 
      skipDefaultHeight={isUrl}
    >
      <Block display="grid" gridGap={20}>
        <Block
          padding={{ all: 20, bottom: 0 }}
          display="grid"
          justifyContent="center"
          justifyItems="center"
          gridGap={10}
        >
          <Block textTransform="uppercase" fontSize="large" color="gray">
            {isDashboard ? t("feeds.add_dashboard") : t("feeds.add_content")}
          </Block>
          <Block fontSize="largest" color="gray" shade="darker">
            {t("feeds.complete_steps_below")}
          </Block>
        </Block>
        <Panel>
          {isUrl ? (
            <Block opacity={!loading ? 1 : 0.3} display="grid" gridGap={24}>
              <FullInput
                title="Copy the URL inside src='...' from your embed code" 
                value={source?.custom_fields?.url ? source.custom_fields.url : ""}
                iconPosition="right"
                icon={<Tooltip
                  placement="left"
                  content="Click the 'Share' or 'Embed' option, then copy the HTML embed snippet provided. Locate the src attribute from that code and copy only the URL within the quotation marks."
                  icon={<Icon name="info" iconSize="small" iconFill="9EABB8" />}
                ></Tooltip>}
                onChange={(event: any) => {
                  setSource({
                    ...source,
                    custom_fields: {
                      ...source.custom_fields,
                      url: event.target.value
                    }
                  });
                }}
              />
            </Block>
          ) : (
            <Block opacity={!loading ? 1 : 0.3} display="grid" gridGap={24}>
              {/* Network Connection */}
              <Select
                title={t(
                  isDashboard
                    ? "feeds.powerbi_accounts"
                    : isTeams
                    ? "feeds.teams_collaboration_accounts"
                    : "feeds.social_media_account"
                )}
                withIcon
                optionWithIconGridTemplate={"60px 1fr"}
                optionWithGridGap={2}
                labelPadding={50}
                withDescription
                icon={
                  <IconLoading
                    loading={loading}
                    activeIcon={
                      connection ? getNetworkIcon(connection) : "search"
                    }
                  />
                }
                styles={{
                  ...SelectStyles,
                  valueContainer: customValueContainer,
                  option: (base, state) => {
                    const _defaultOptionStyles = SelectStyles.option
                      ? SelectStyles.option(base, state)
                      : {};
                    return {
                      ...base,
                      ..._defaultOptionStyles,
                      marginBottom: last(state.options) === state.data ? 8 : 0,
                    };
                  },
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: theme.header.zIndex * 2 + 1,
                  }),
                  menuList: (base) => ({
                    ...base,
                    paddingBottom: 0,
                    paddingTop: hasConnections ? 8 : 0,
                    marginBottom: 0,
                    maxHeight: 400,
                  }),
                }}
                options={connections}
                captureMenuScroll={false}
                components={{
                  Option: OptionWithMedia("wideicon"),
                  MenuList: (mlList) => (
                    <MenuList
                      channel={channel}
                      availableNetworks={chain(availableNetworks || {})
                        .map()
                        .orderBy("uiOrder")
                        .value()}
                      onAddNewConnection={initialAddConnection}
                      hasConnections={hasConnections}
                      {...mlList}
                    />
                  ),
                }}
                value={
                  (connection &&
                    connections.find(
                      (c: any) => c.value === String(connection.id)
                    )) ||
                  null
                }
                onChange={selectConnection}
              />

              {/* Types selection */}
              
              {types && types.length > 1 && selectedType && (
                <>
                <Select
                  value={{
                    ...selectedType,
                    label: t(selectedType.label),
                    value: selectedType.label,
                  }}
                  title={t("feeds.content_type")}
                  options={types.map((o) => ({
                    ...o,
                    label: t(o.label),
                    value: o.label,
                  }))}
                  labelPadding={50}
                  withIcon
                  icon={
                    <MediumSelectIcon
                      color="gray"
                      name="profile"
                      iconSize="large"
                    />
                  }
                  styles={{
                    ...SelectStyles,
                    valueContainer: customValueContainer,
                  }}
                  opacity={connections && connections.length > 0 ? 1 : 0.5}
                  isDisabled={
                    connections && connections.length > 0 ? false : true
                  }
                  onChange={(type: any) => {
                    onTypeChange(type);
                  }}
                />
                </>
              )}

              {/* Static Account options */}
              {!query &&
                !singleInputOption.active &&
                selectedType && 
                selectedType?.type !== TypesEnum.SHAREPOINTSITE &&
                selectedType?.type !== TypesEnum.POWERBIDASHBOARD &&
                typeOptions && (
                  <>
                  <Select
                    withIcon
                    labelPadding={50}
                    styles={{
                      ...SelectStyles,
                      valueContainer: customValueContainer,
                    }}
                    icon={<SelectIcon color="gray" name={selectedType.icon} />}
                    title={t(selectedType.label)}
                    value={selectedTypeOption}
                    options={typeOptions.map((o) => ({
                      ...o,
                      label: o.name,
                      value: o.id,
                    }))}
                    opacity={typeOptions.length <= 1 ? 1 : 0.5}
                    components={{
                      Option: OptionWithMedia("auto"),
                      DropdownIndicator: null,
                      IndicatorSeparator: null,
                    }}
                    onChange={(selected: any) => {
                      onStaticAccountChange(selected);
                    }}
                  />
                  </>
                )}
      
              {renderSharePointFields()}
              {renderPowerBiFields()}

              {/* Secondary Static Account options */}
              {!query &&
                !singleInputOption.active &&
                selectedType &&
                selectedTypeSecondaryOption &&
                typeSecondaryOptions && (
                  <>
                  <Select
                    withIcon
                    labelPadding={50}
                    styles={{
                      ...SelectStyles,
                      valueContainer: customValueContainer,
                    }}
                    icon={<SelectIcon color="gray" name={selectedType.icon} />}
                    title={t(selectedType.secondaryLabel || "")}
                    value={selectedTypeSecondaryOption}
                    options={typeSecondaryOptions.map((o) => ({
                      ...o,
                      label: o.name,
                      value: o.id,
                    }))}
                    isDisabled={typeSecondaryOptions.length <= 1}
                    opacity={typeSecondaryOptions.length <= 1 ? 1 : 0.5}
                    components={{
                      Option: OptionWithMedia("auto"),
                      DropdownIndicator: null,
                      IndicatorSeparator: null,
                    }}
                    onChange={(selected: any) => {
                      onStaticAccountChange(selected, true);
                    }}
                  />
                  </>
                )}
              {/* Dynamic Slack Account search */}
              {query && !singleInputOption.active && selectedType && typeOptions && (
                <>
                  {!slackSearch && (
                    <>
                    <span>4</span>
                    <FullInput
                      customStyles={singleInputCustomStyles}
                      icon={<SelectIcon color="gray" name={selectedType.icon} />}
                      title={"Slack ID"}
                      value={slackId}
                      onChange={({ target: { value } }) => {
                        setSlackId(value);
                        setAsyncInputValue(value);
                        onDynamicAccountChange({
                          channel_id: value,
                          name: value,
                          label: value,
                          value: value,
                          icon: "slack",
                        });
                        }}
                      />
                    </>
                  )}

                  {(slackSearch || yammerSearch) && (
                    <AsyncSelect
                      key="async-select-field"
                      {...({ ref: asyncSelectRef } as any)}
                      loadOptions={loadAsyncOptions}
                      withDescription
                      ignorePadding={true}
                      alwaysPadding={true}
                      labelPadding={50}
                      styles={{
                        ...SelectStyles,
                        valueContainer: customValueContainer,
                        input: (provided) => {
                          return { ...provided, minWidth: 50 };
                        },
                      }}
                      inputValue={asyncInputValue}
                      onFocus={() => {
                        if (asyncInputRef && asyncInputRef.current) {
                          const el = asyncInputRef.current;
                          el.focus();
                          const end = el.value.length;
                          el.setSelectionRange(end, end);
                        }
                      }}
                      onInputChange={(
                        input: string,
                        reason: { action: string }
                      ) => {
                        // "set-value" fires both right after picking an
                        // option AND when backspacing the last character -
                        // react-select reports the same action for both, so
                        // the reason code alone can't tell them apart. Only
                        // skip the update when we know it's really the
                        // former (flag set in onChange) - consumed as a
                        // one-shot here so it can't get stuck set to true.
                        const wasJustSelected = justSelectedOptionRef.current;
                        justSelectedOptionRef.current = false;
                        if (input === "" && wasJustSelected) {
                          return;
                        }
                        if (reason.action === "input-blur") {
                          return;
                        }
                        setAsyncInputValue(input);
                        if (input == "") {
                          setSelectedTypeOption(undefined);
                        }
                      }}
                      withIcon
                      noOptionsMessage={() => null}
                      icon={
                        <SelectIcon name={selectedType.icon} iconSize="large" />
                      }
                      title={t(selectedType.label)}
                      value={selectedTypeOption}
                      components={asyncSelectComponents}
                      onChange={(selected: any) => {
                        justSelectedOptionRef.current = true;
                        setAsyncInputValue(
                          yammerSearch ? selected.channel_name : selected.name
                        );
                        onDynamicAccountChange(selected);
                      }}
                    />
                  )}
                </>
              )}

              {/* Single input  */}
              {singleInputOption.active && selectedType && (
                <FullInput
                  // explicit key: if any preceding conditional sibling ever
                  // toggles presence, an unkeyed element here would shift
                  // position and React would remount it - pin identity so
                  // that can't happen regardless of what else changes.
                  key="single-input-field"
                  customStyles={singleInputCustomStyles}
                  icon={<SelectIcon color="gray" name={selectedType.icon} />}
                  title={selectedType.label}
                  value={singleInputOption.value}
                  onChange={(e: any) => {
                    onSingleInputChange(e.target.value);
                  }}
                />
              )}

            {selectedType?.type !== TypesEnum.POWERBIDASHBOARD && (
              <>
                {/* Hide older than */}
                <Select
                  // was defaultValue - Select always renders controlled, so
                  // it never picked up onChange, just kept showing "Show all"
                  value={
                    hidePostsOptions.find(
                      (option) =>
                        String(option.value) === String(source.hide_older_than)
                    ) ||
                    (!!firstItem
                      ? hidePostsOptions.find(
                          (option) =>
                            String(option.value) ===
                            String(firstItem.hide_older_than)
                        ) || hidePostsOptions[0]
                      : hidePostsOptions[0])
                  }
                  title={t("feeds.hide_older_than")}
                  options={translateCollection(hidePostsOptions, t)}
                  withIcon
                  labelPadding={50}
                  icon={<SelectIcon color="gray" name="eye" iconSize="large" />}
                  styles={{
                    valueContainer: customValueContainer,
                  }}
                  opacity={
                    connection && connections && connections.length > 0 ? 1 : 0.5
                  }
                  // isDisabled={
                  // connection && connections && connections.length > 0
                  //   ? false
                  //   : true
                  // }
                  isDisabled={
                    !firstItem &&
                    connection &&
                    connections &&
                    connections.length > 0
                      ? false
                      : true
                  }
                  onChange={(selected: any) => {
                    setSource({
                      ...source,
                      hide_older_than: selected.value,
                    });
                  }}
                />
              </>
            )}

            {/* WebEx custom hashtag input */}
            {source.type == TypesEnum.WEBEXROOM && selectedType && (
              <FullInput
                icon={<SelectIcon color="gray" name="hashtag" />}
                customStyles={singleInputCustomStyles}
                title="Hashtag"
                value={source.custom_fields.hashtag}
                onChange={({ target: { value } }) => {
                  setSource({
                    ...source,
                    custom_fields: {
                      ...source.custom_fields,
                      hashtag: value || "",
                    },
                  });
                }}
              />
            )}

              {selectedType?.type !== TypesEnum.POWERBIDASHBOARD && (
                <>
                  {/* Curation type */}
                  <Select
                    defaultValue={CURATION_TYPES_OPTIONS[0]}
                    title={t("feeds.curation_type")}
                    options={translateCollection(CURATION_TYPES_OPTIONS, t, "label")}
                    withIcon
                    labelPadding={50}
                    icon={
                      <MediumSelectIcon color="gray" name="bolt" iconSize="large" />
                    }
                    styles={{
                      valueContainer: customValueContainer,
                    }}
                    opacity={
                      connection && connections && connections.length > 0 ? 1 : 0.5
                    }
                    isDisabled={
                      connection && connections && connections.length > 0
                        ? false
                        : true
                    }
                    onChange={(selected: any) => {
                      setSource({
                        ...source,
                        curation_type: selected.value,
                      });
                    }}
                  />
                </>
              )}

              {selectedType?.type === TypesEnum.POWERBIDASHBOARD && (
                <>
                  <Select
                    defaultValue={
                      orientationOptions[0]
                    }
                    title={t("feeds.orientation")}
                    options={translateCollection(orientationOptions, t)}
                    withIcon
                    labelPadding={50}
                    icon={<SelectIcon color="gray" name="refresh" iconSize="large" />}
                    styles={{
                      valueContainer: customValueContainer,
                    }}
                    onChange={(selected: any) => {
                      setSource({
                        ...source,
                        custom_fields: {
                          ...source.custom_fields,
                          orientation: selected.value,
                        },
                      });
                    }}
                  />
                </>
              )}

              {/* Twitter advanced options */}
              {(source.type == TypesEnum.TWITTERACCOUNT ||
                source.type == TypesEnum.TWITTERTAG) && (
                <>
                  <PanelHeader
                    headerSize="small"
                    title={t("feeds.retweets_replies_header")}
                  />
                  <Block display="grid" direction="column" gridGap={20}>
                    <Checkbox
                      type="checkbox"
                      checked={source.custom_fields.retweets}
                      onChange={(event: any) => {
                        setSource({
                          ...source,
                          custom_fields: {
                            ...source.custom_fields,
                            retweets: !source.custom_fields.retweets,
                          },
                        });
                      }}
                      title={t("feeds.include_retweets")}
                    />
                  </Block>{" "}
                </>
              )}

              {/* WebEx advanced option */}
              {source.type == TypesEnum.WEBEXROOM && (
                <>
                  <Select
                    defaultValue={WEBEX_ONLY_MY_POSTS[0]}
                    title={t("Posts to show")}
                    options={translateCollection(WEBEX_ONLY_MY_POSTS, t)}
                    opacity={
                      connection && connections && connections.length > 0
                        ? 1
                        : 0.5
                    }
                    isDisabled={
                      connection && connections && connections.length > 0
                        ? false
                        : true
                    }
                    onChange={(selected: any) => {
                      setSource({
                        ...source,
                        custom_fields: {
                          ...source.custom_fields,
                          my_posts_only: JSON.parse(selected.value),
                        },
                      });
                    }}
                  />
                </>
              )}

              {/* Error handling */}
              {errors.error && (
                <WarningPanel>
                  {errors.message || t("generals.error_title")}
                </WarningPanel>
              )}
            </Block>
          )}
        </Panel>
        <ModalButtons
          onCancel={onCancel}
          submit={
            isSubmitting ? (
              <Icon name="loading" strokeColor="white" />
            ) : (
              isDashboard ? t("feeds.add_dashboard") : t("feeds.add_content")
            )
          }
          ctaType={isSubmitting ? "cta" : "cta"}
          disableSubmit={isUrl ? !isValid : (!isValid || isSubmitting || isSharePointValidating || isPowerBiValidating) }
          cancel={t("CANCEL")}
          onSubmit={() => submit()}
        />
      </Block>
      {isOpen && selectedNetwork && (
        <ManageSocialNetworkModal
          customStyle={{
            overlay: { zIndex: Number(theme.header.zIndex * 2 + 2) },
          }}
          selectedNetwork={selectedNetwork}
          isOpen={isOpen}
          onSubmit={onConnectionAdded}
          onCancel={() => {
            toggleModal(false);
          }}
        />
      )}
    </Modal>
  );
};

export { AddFeedModal };
